import FavoriteManager from './favoriteManager';
import "./favorite.less";

export default FavoriteManager;
